module.exports = __webpack_public_path__ + "static/img/play-conceptphoto.0cd2458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play-conceptphoto.jpg
// module id = 6YqD
// module chunks = 1